import React, { useState, useEffect } from "react";
import "./ItemListContainer.css";
import { db } from "../../utils/firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { ItemList } from "../ItemList/ItemList";

export const ItemListContainer = () => {
  const [items, setItems] = useState([]);
  const { categoryId } = useParams();
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getData = async () => {
      const queryRef = !categoryId
        ? collection(db, "productos")
        : query(
            collection(db, "productos"),
            where("category", "==", categoryId)
          );
          const response = await getDocs(queryRef);
          const productos = response.docs.map((doc) => {
            console.log(doc.data())
            const newProduct = {
          
          ...doc.data(),
          id: doc.id,
        };
        return newProduct;
      });
      setTimeout(()=>{
        setItems(productos);
        setLoading(false)
      }, 500)

    };
    getData();
  }, [categoryId]);
  console.log(items);
  return (
    loading ?  
    <div className="loadingContainer flex justify-center	items-center	">
      <button className="btn btn-square  loading btnLoading"></button>
    </div>
     :
    <section className="indexContainer w-full pt-5">
      <ItemList items={items} />
    </section>
  );
};
